import React from "react";
import "./DrumTruck.css";

const DrumTruck = () => {
  return (
    <div>
      <h1>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolorum,
        voluptatem?
      </h1>
    </div>
  );
};

export default DrumTruck;
